<template>
  <svg
    class="h-full"
    viewBox="0 0 412 852"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4310_2883)">
      <rect width="1280" height="942" fill="#FDF5D0" />
      <g clip-path="url(#clip1_4310_2883)">
        <path
          d="M62 -99C122.751 -99 172 -49.5275 172 11.5C172 72.5275 122.751 122 62 122H-213C-243.376 122 -268 97.2637 -268 66.75C-268 36.2363 -243.376 11.5 -213 11.5H-153.305C-141.979 -20.6883 -111.421 -43.75 -75.5 -43.75C-61.9792 -43.75 -49.2178 -40.483 -37.9561 -34.6914C-20.5439 -72.6509 17.6644 -99 62 -99Z"
          fill="white"
        />
      </g>
      <circle cx="300" cy="132" r="62" fill="#F8D744" />
      <path
        d="M298.569 161.753C299.111 161.573 299.696 161.867 299.877 162.409C300.056 162.95 299.763 163.536 299.221 163.716C292.593 165.922 285.742 166.686 278.676 166.012C278.108 165.958 277.69 165.454 277.744 164.886C277.798 164.318 278.303 163.902 278.87 163.956C285.655 164.603 292.219 163.867 298.569 161.753Z"
        fill="black"
      />
      <path
        d="M312.667 124.942C313.135 125.052 313.631 124.822 313.841 124.37C314.08 123.852 313.854 123.237 313.336 122.998L312.8 122.759C307.424 120.449 301.313 120.405 296.454 122.611L295.972 122.837L295.795 122.95C295.416 123.245 295.283 123.774 295.503 124.221C295.724 124.669 296.226 124.886 296.691 124.764L296.887 124.692L297.743 124.303C302.1 122.493 307.619 122.631 312.469 124.873L312.667 124.942Z"
        fill="black"
      />
      <path
        d="M270.31 124.942C270.777 125.052 271.274 124.822 271.483 124.37C271.723 123.852 271.496 123.237 270.978 122.998L270.443 122.759C265.067 120.449 258.955 120.405 254.097 122.611L253.614 122.837L253.438 122.95C253.058 123.245 252.925 123.774 253.146 124.221C253.367 124.669 253.869 124.886 254.334 124.764L254.53 124.692L255.385 124.303C259.743 122.493 265.262 122.631 270.111 124.873L270.31 124.942Z"
        fill="black"
      />
      <path
        d="M274.167 115.467C274.167 114.896 274.629 114.434 275.2 114.434C275.771 114.434 276.233 114.896 276.233 115.467V143.214L285.769 145.462L285.967 145.528C286.404 145.73 286.652 146.217 286.538 146.703C286.424 147.189 285.984 147.515 285.503 147.5L285.297 147.472L274.964 145.038C274.497 144.928 274.167 144.512 274.167 144.033V115.467Z"
        fill="black"
      />
      <path
        d="M270.108 101.555C270.578 101.658 271.072 101.42 271.274 100.963C271.476 100.506 271.32 99.981 270.929 99.7026L270.746 99.6011C263.837 96.5461 255.823 96.5256 249.637 99.4787C249.122 99.7245 248.902 100.342 249.147 100.857C249.393 101.371 250.01 101.589 250.525 101.344C256.115 98.6749 263.498 98.6542 269.91 101.489L270.108 101.555Z"
        fill="black"
      />
      <path
        d="M315.196 101.555C315.665 101.658 316.159 101.42 316.361 100.963C316.563 100.506 316.408 99.981 316.016 99.7026L315.833 99.6011C308.925 96.5461 300.91 96.5256 294.724 99.4787C294.209 99.7245 293.989 100.342 294.235 100.857C294.481 101.371 295.098 101.589 295.613 101.344C301.203 98.6749 308.586 98.6542 314.997 101.489L315.196 101.555Z"
        fill="black"
      />
      <rect y="786" width="412" height="66" fill="#68C5FF" />
      <path
        d="M-288 668C-76.7151 668 101.225 725.141 154.63 802.919C373.125 817.02 540 892.85 540 984.282C540 1085.75 334.499 1168 81 1168C-130.286 1168 -308.227 1110.86 -361.631 1033.08C-580.126 1018.98 -747 943.15 -747 851.718C-747 750.253 -541.499 668 -288 668Z"
        fill="#FAE173"
      />
      <g clip-path="url(#clip2_4310_2883)">
        <path
          d="M399 121C353.713 121 317 157.713 317 203C317 248.287 353.713 285 399 285H604C626.644 285 645 266.644 645 244C645 221.356 626.644 203 604 203H559.5C551.057 179.114 528.277 162 501.5 162C491.421 162 481.909 164.425 473.514 168.723C460.534 140.553 432.05 121 399 121Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4310_2883">
        <rect width="412" height="852" fill="white" />
      </clipPath>
      <clipPath id="clip1_4310_2883">
        <rect
          width="440"
          height="221"
          fill="white"
          transform="translate(-268 -99)"
        />
      </clipPath>
      <clipPath id="clip2_4310_2883">
        <rect
          width="328"
          height="164"
          fill="white"
          transform="matrix(-1 0 0 1 645 121)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
